<template>
	<div class="login-page">
		<el-row>
			<el-col :span="14" :offset="5">
				<el-row class="login-box">
					<div class="login-header">
						用户登录
					</div>
					<div class="content-box">
						<div class="login-content">
							<div class="login-inputBox">
								<div class="login-item">用户名：</div>
								<div class="login-input">
									<el-input placeholder="请输入用户名" v-model="username" clearable></el-input>
								</div>
							</div>
							<div class="login-inputBox">
								<div class="login-item">密码：</div>
								<div class="login-input">
									<el-input placeholder="请输入密码" v-model="password" clearable show-password></el-input>
								</div>
							</div>
							<el-button type="primary login-btn" @click="login()">登录</el-button>
						</div>

					</div>
				</el-row>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import './index.less';
	export default {
		name: 'login',
		data() {
			return {
				username: '',
				password: '',
			}
		},
		methods: {
			login() {
				if (!this.username || !this.password) {
					this.$message({
						message: '用户名或密码未输入！',
						type: 'warning'
					});
				} else if (this.username != 'admin' || this.password != '123456') {
					this.$message.error('用户名或密码错误！');
				} else {
					this.$message({
						message: '登录成功！',
						type: 'success'
					});
				}

			}
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/login/index.vue